// Tiny presentational pieces shared by every CRM view. Styles are inline so
// they render the same wherever they are used (scoped CSS does not reach
// functional children).
import { VIcon } from 'vuetify/lib'
import { crm, STATUS_COLORS, PRIORITY_COLORS, avatarColor, initials, memberName } from '../crmStore'

function hexA (hex, a) {
  const h = hex.replace('#', '')
  const n = parseInt(h.length === 3 ? h.split('').map(c => c + c).join('') : h, 16)
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`
}

export const CrmChip = {
  name: 'CrmChip',
  functional: true,
  props: { kind: { type: String, default: 'status' }, value: String, small: Boolean, label: String, entity: String },
  render (h, { props, parent }) {
    if (!props.value) return null
    let color
    let text = props.label
    if (props.kind === 'priority') {
      color = PRIORITY_COLORS[props.value]
      text = text || parent.$t('crmPriority_' + props.value)
    } else {
      // workspace-defined statuses (lead / person / company) first, doc §6.5.1
      const lists = props.entity ? [crm.statuses[props.entity] || []] : (props.entity === 'deal' ? [] : [crm.statuses.lead, crm.statuses.person, crm.statuses.company])
      let meta = null
      if (props.entity !== 'deal') lists.some(l => (meta = (l || []).find(x => x.key === props.value)))
      color = (meta && meta.color) || STATUS_COLORS[props.value]
      text = text || (meta && meta.title) || parent.$t('crmStatus_' + props.value)
    }
    color = color || '#8a94a6'
    return h('span', {
      class: 'crm-chip',
      style: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        height: props.small ? '20px' : '24px',
        padding: props.small ? '0 7px' : '0 9px',
        borderRadius: '6px',
        fontSize: props.small ? '.7rem' : '.75rem',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        color,
        background: hexA(color, 0.11)
      }
    }, [
      h('i', { style: { width: '6px', height: '6px', borderRadius: '50%', background: color, flexShrink: 0 } }),
      text
    ])
  }
}

export const CrmAvatar = {
  name: 'CrmAvatar',
  functional: true,
  props: { userId: [Number, String], name: String, size: { type: Number, default: 26 } },
  render (h, { props }) {
    const name = props.name || memberName(props.userId)
    const base = {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: props.size + 'px',
      height: props.size + 'px',
      borderRadius: '50%'
    }
    if (name && name.charAt(0) === '#') {
      // owner exists but is not in the loaded member list: neutral person icon
      return h('span', {
        attrs: { title: name },
        style: { ...base, background: 'rgba(127,127,127,.18)' }
      }, [h(VIcon, { props: { xSmall: true } }, 'mdi-account')])
    }
    if (!name) {
      return h('span', {
        attrs: { title: '—' },
        style: { ...base, border: '1px dashed rgba(127,127,127,.5)', color: 'rgba(127,127,127,.8)' }
      }, [h(VIcon, { props: { xSmall: true } }, 'mdi-account-outline')])
    }
    return h('span', {
      attrs: { title: name },
      style: {
        ...base,
        color: '#fff',
        fontWeight: 700,
        letterSpacing: 0,
        fontSize: Math.round(props.size * 0.38) + 'px',
        background: avatarColor(name)
      }
    }, initials(name))
  }
}

export { hexA }
